import React, { useState } from 'react'
import LoyaltyWidget from './LoyaltyWidget'
import LoyaltyBenefits from './LoyaltyBenefits'
import LoyaltyStatement from './LoyaltyStatement'

const styles = {
  container: {
    padding: '20px',
    maxWidth: '800px',
    margin: '0 auto'
  },
  header: {
    marginBottom: '20px'
  },
  title: {
    fontSize: '1.3rem',
    fontWeight: 700,
    color: '#111827',
    marginBottom: '4px'
  },
  subtitle: {
    fontSize: '0.85rem',
    color: '#6b7280'
  },
  tabs: {
    display: 'flex',
    gap: '4px',
    marginBottom: '20px',
    borderBottom: '1px solid #e5e7eb',
    paddingBottom: '0'
  },
  tab: (active) => ({
    padding: '10px 16px',
    fontSize: '0.85rem',
    fontWeight: active ? 600 : 500,
    color: active ? '#006aff' : '#6b7280',
    backgroundColor: 'transparent',
    border: 'none',
    borderBottom: active ? '2px solid #006aff' : '2px solid transparent',
    cursor: 'pointer',
    transition: 'all 0.2s',
    marginBottom: '-1px'
  }),
  section: {
    marginTop: '16px'
  },
  widgetSection: {
    marginBottom: '20px'
  }
}

function LoyaltyPage({ brand, token }) {
  const [activeTab, setActiveTab] = useState('saldo')

  const handleNavigate = (section) => {
    setActiveTab(section)
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div style={styles.title}>Programa de Fidelidade</div>
        <div style={styles.subtitle}>Acumule pontos e resgate benefícios exclusivos</div>
      </div>

      <div style={styles.tabs}>
        <button
          style={styles.tab(activeTab === 'saldo')}
          onClick={() => setActiveTab('saldo')}
        >
          Meu Saldo
        </button>
        <button
          style={styles.tab(activeTab === 'beneficios')}
          onClick={() => setActiveTab('beneficios')}
        >
          Benefícios
        </button>
        <button
          style={styles.tab(activeTab === 'extrato')}
          onClick={() => setActiveTab('extrato')}
        >
          Extrato
        </button>
      </div>

      <div style={styles.section}>
        {activeTab === 'saldo' && (
          <div>
            <div style={styles.widgetSection}>
              <LoyaltyWidget brand={brand} token={token} onNavigate={handleNavigate} />
            </div>
          </div>
        )}

        {activeTab === 'beneficios' && (
          <LoyaltyBenefits brand={brand} token={token} />
        )}

        {activeTab === 'extrato' && (
          <LoyaltyStatement brand={brand} token={token} />
        )}
      </div>
    </div>
  )
}

export default LoyaltyPage
